export const colors = {
  gvRed: '#EA3632',
  gvBlack: '#000000',
  gvGreen: '#2ED2AB',
  gvDarkred: '#BA0C2F',
  gvYellow: '#FF9800',
  gvWhite: '#FFFFFF',
  gvExpired: 'rgb(135, 146, 171)',
  gvDisabled: 'rgb(135, 146, 171)',
  lightText: 'var(--gds-color-text-secondary)',
  darkText: 'var(--gds-color-cool-gray-900)',
  background: 'var(--gds-color-cool-gray-700)',
  gvError: '#BA0C2F',
  gvLightGrey: '#8A8C9F',
  gvLightBlue: '#6DDAE2',
};

export const components = {
  checkbox: {
    ripple: 'rgba(234,54,50,0.32)',
    iconSize: '1.25rem',
  },
  select: {
    height: '40px',
    minWidth: '125px',
  },
};

export default {
  colors,
  components,
};
